import { Component, Input, OnInit, HostListener} from "@angular/core";

import { ConsultaIpocService } from "./consulta-ipoc.service";
import { TrocaIPOCDTO, DiasAtrasoDTO, ConsultasOperacaoScrDTO } from "src/app/model/consulta-ipoc.model";
import { EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import Utils from "src/app/shared/fgi-utils";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";


@Component({
    selector: 'app-consulta-ipoc-detalhe',
    templateUrl: './consulta-ipoc-pesquisa.component.html',
    styleUrls: ['./consulta-ipoc-pesquisa.component.scss'],
    standalone: false
})
export class ConsultaIpocPesquisaComponent implements OnInit{

  @Input() public idOperacao: number;
  @Input() public idIPOC: string;
  public permissaoEdicao:  boolean;

  public trocasIPOC: TrocaIPOCDTO[];
  public diasAtraso: DiasAtrasoDTO[] = [];
  public consultasOperacaoScr: ConsultasOperacaoScrDTO[] = [];
  public pesquisado: boolean = false
  public atributosPaginacaoAbaTrocaIpoc: EntityPagedRequestParameters;
  public atributosPaginacaoAbaDiasAtraso: EntityPagedRequestParameters;
  public atributosPaginacaoAbaConsultaBacen: EntityPagedRequestParameters;
  public opcoesPaginacaoDiasAtraso: number[];
  public opcoesPaginacaoTrocaIpoc: number[];
  public opcoesPaginacaoAbaConsultaBacen: number[];
  public consultaBacenPesquisado: boolean = false;
  public opcaoMostrarTodosIpocs: boolean = false;

  
  constructor(
    private consultaIpocService: ConsultaIpocService,
    private permissaoService: PermissaoService,
    private alertService: BnAlertsService){
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
      this.buscar();
  }


  ngOnInit(): void {
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
      this.permissaoEdicao = resp[ROLE_GESTOR_ENVIO];
    })
    this.opcoesPaginacaoTrocaIpoc = [10, 15, 20];
    this.atributosPaginacaoAbaTrocaIpoc = {
      page: 1,
      pageSize: this.opcoesPaginacaoTrocaIpoc[0]
    };

    this.opcoesPaginacaoAbaConsultaBacen = [10, 15, 20];
    this.atributosPaginacaoAbaConsultaBacen = {
      page: 1,
      pageSize: this.opcoesPaginacaoAbaConsultaBacen[0]
    };

    this.opcoesPaginacaoDiasAtraso = [10, 15, 20];
    this.atributosPaginacaoAbaDiasAtraso = {
      page: 1,
      pageSize: this.opcoesPaginacaoDiasAtraso[0]
    };
  }

  public buscar(): void {
    this.pesquisado = false;
    if (this.idOperacao == null && this.idIPOC == null) {
      this.alertService.alertaErro('Erro', 'Preencha o campo ID Operação ou Número IPOC');
    }

    if(this.idOperacao || this.idOperacao === 0) {
      this.buscaIpoc();
      this.buscaAtraso();
      this.consultasOperacaoScr = [];
      this.idIPOC = null;

    }
    if (this.idIPOC != null && this.idIPOC != '' && !(this.idOperacao || this.idOperacao === 0)) {
      this.buscaIPOCporIpoc();
      this.consultasOperacaoScr = [];      
    }
    this.opcaoMostrarTodosIpocs = false;

  }

  private buscaIPOCporIpoc(): void {

    this.consultaIpocService.getTrocaIPOCporIPOC(this.idIPOC)
      .subscribe((ipocs: TrocaIPOCDTO[]) => {
        this.trocasIPOC = ipocs.sort((a, b) => -1 * Utils.compara(a, b, 'dataBase'));
        this.idOperacao = this.trocasIPOC[0].idOperacaoGarantida;
        this.buscaAtraso();
        this.pesquisado = true;
      });
  }

  private buscaIpoc(): void {

    this.consultaIpocService.getTrocaIPOC(this.idOperacao)
      .subscribe((ipocs:TrocaIPOCDTO[]) => {
        this.trocasIPOC = ipocs.sort((a, b) => -1 * Utils.compara(a, b, 'dataBase'));
        this.pesquisado = true;
      });
  }


  private buscarTodasTrocasIpoc(){
    this.consultaIpocService.getTodasTrocasIPOC(this.idOperacao).subscribe((ipocs: TrocaIPOCDTO[]) =>{
      this.trocasIPOC = ipocs.sort((a, b) => -1 * Utils.compara(a, b, 'dataBase'));
    })
  }

  private buscarConsultasOperacaoSCR(): void {

    this.consultaIpocService.getConsultasOperacaoSCR(this.idOperacao)
      .subscribe((res:ConsultasOperacaoScrDTO[]) => {
        this.consultasOperacaoScr = res;
        this.pesquisado = true;
      });
  }


  private buscaAtraso():void {

    this.consultaIpocService.getDiasAtraso(this.idOperacao)
      .subscribe((atraso:DiasAtrasoDTO[]) => {
        this.diasAtraso = atraso;
        this.pesquisado = true;
      });
  }

  onNavChange(event: NgbNavChangeEvent) {
    if (event.nextId == '1') {
      if(this.consultasOperacaoScr.length ==0){
        this.buscarConsultasOperacaoSCR();
      }
    }
}

  public limpar() {
    this.opcaoMostrarTodosIpocs = false;
    this.pesquisado = false;
    this.idOperacao = null
    this.idIPOC = null;
    this.trocasIPOC = [];
    this.diasAtraso = [];
    this.consultasOperacaoScr = [];
  }

  public trocarOpcaoMostrarTodosIpocs (){
    if(!this.idOperacao) {
      this.alertService.alertaErro('Erro', 'Preencha o campo ID Operação');
      return;
    }
    if(this.opcaoMostrarTodosIpocs) {
      this.buscarTodasTrocasIpoc();
      this.pesquisado = true;
    }
    else{
      this.buscaIpoc();
      this.pesquisado = true;
    }
  }


}















